import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChevronDoubleRightFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.16 11.96L12.8 19.32L11.38 17.9L17.32 11.96L11.38 6.02L12.8 4.6L20.16 11.96ZM12.58 11.96L5.22 19.32L3.8 17.9L9.74 11.96L3.8 6.02L5.22 4.6L12.58 11.96Z" />
    </SvgIcon>
  );
});
